import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../../moreCore/UI/Button/Button";
import OrchestraMatrixPEP from './OrchestraMatrixPEP';
import _MatrixManagerBase from '../../moreCore/UI/Matrix/_MatrixManagerBase';

class MatrixManagerPEP extends compose(_WidgetBaseSP) {
    templateString = "<div></div>";
    private matrix: MdsLax<InstanceType<typeof OrchestraMatrixPEP>>;

	

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

       
	}


    startup(): void {
		super.startup.apply(this, arguments as any);

        this.matrix = new OrchestraMatrixPEP();
        this.matrix.placeAt(this.domNode);
        //this.matrix.setup({
        //    loadContentAPI: 'Webtool_API_EvTaskMatrix__GetData_ContentCells',
        //    saveAPI: 'Webtool_API_EvTaskMatrix__CommitContent',
        //    selectionValuesAPI: 'Webtool_API_EvTaskMatrix__GetData_SelectionValues',
        //    xAxisAPI: 'Webtool_API_EvTaskMatrix__GetData_X',
        //    yAxisAPI: 'Webtool_API_EvTaskMatrix__GetData_Y'
        //});

        this.matrix.setup({
            loadContentAPI: 'Webtool_API_PepMatrix__GetData_ContentCells',
            saveAPI: 'Webtool_API_PepMatrix__CommitContent',
            selectionValuesAPI: 'Webtool_API_PepMatrix__GetData_SelectionValues',
            xAxisAPI: 'Webtool_API_PepMatrix__GetData_X',
            yAxisAPI: 'Webtool_API_PepMatrix__GetData_Y'
        });
    }
}

export default mdsWidget(MatrixManagerPEP);